<template>
    <BaseLayout>
 
      <!-- 主内容 --> 
      <ProductDetail :images="swiperImg" :currObj="pOnlyObj"/>
       
    </BaseLayout>
</template>
  
<script> 
import {mapState} from 'vuex';
import BaseLayout from '@/components/BaseLayout.vue'; 
import ProductDetail from '@/components/ProductDetail.vue'; 
export default { 
    name: 'rincessView',
    components: {
        BaseLayout,  
        ProductDetail
    },
    data() {
        return {
            pOnlyObj:{},
            swiperImg:[],
            productImages: [
                require('@/assets/banner/bg.jpg'),
                require('@/assets/banner/bg2.jpg'),
                require('@/assets/banner/bg2.jpg'),
                require('@/assets/banner/bg.jpg'),
            ],
        };
    }, 
    computed: {
        ...mapState['princessIndex'], 
    }, 
    mounted() {
        this.handlData();
    },
    methods:{
        handlData(){
            try{
                let _pid = this.$store.state.princessIndex;
                let _swList = [];
                let _jjList = [];

                let baseInfoJson = this.$local.getItem('baseInfoJson');  
                if(baseInfoJson){
                    let baseInfo = JSON.parse(baseInfoJson);
                    _swList = baseInfo.princess;
                    _jjList = baseInfo.product;
                }

                this.pOnlyObj =  _swList.find(item => {
                    if(item.id == _pid)return item;
                });
                if(!this.pOnlyObj){
                    this.pOnlyObj =  _jjList.find(item => {
                    if(item.id == _pid)return item;
                });
                }
        
                let arr = this.pOnlyObj.picimages.split(",");
                let temparr = [];
                for (let i = 0; i < arr.length; i++) {
                    temparr.push(this.$store.state.apiUrl + arr[i]);    
                }
                this.swiperImg =temparr;
            }
            catch(err){
               this.$router.push("/");
            }
            // console.log('---this._pid ',_pid)
            // console.log('---this.pOnlyObj ',this.pOnlyObj)
        }
    } 
};
</script>